/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountSelection.scss';

import classnames from 'classnames';
import { func, object, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getAllAccountsforSelection } from 'state/account/AccountSelectors';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const AccountNumber = ({ accountNumber }) => <span>{accountNumber}</span>;

const Owners = ({ owners }) => <span>{owners}</span>;

const AccountNumberWithPermissions = WithUserPermissions(AccountNumber);
const OwnersWithPermissions = WithUserPermissions(Owners);

const AccountSelection = ({
  accountsForSelection,
  currentAccountId,
  onSelect
}) => {
  const accountTypes = Object.keys(accountsForSelection);

  const accountsToSelect = accountTypes.map((accountType, idx) => {
    const accountList = accountsForSelection[accountType];
    return (
      <div className="account-type" key={`account-list:${idx}`}>
        <h2 className="account-type-header">{accountType}</h2>
        <div className="account-type-list">
          {accountList.map((account) => {
            const {
              accountId,
              accountName,
              numberWithChecksum,
              owners,
              ticker
            } = account;
            const className = classnames('account-selector-account', {
              selectedAccount: accountId === currentAccountId
            });
            return (
              <div
                className={className}
                key={accountId}
                onClick={() => onSelect(accountId)}>
                <div className="account-selector-name">
                  {accountName}
                  <div className="account-selector-ticker">{ticker}</div>
                </div>
                <div className="checksum-owners">
                  <AccountNumberWithPermissions
                    accountNumber={numberWithChecksum}
                    shouldMask
                  />
                  <span className="spacing-dot"></span>
                  <OwnersWithPermissions owners={owners} shouldMask />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  });
  return (
    <div>
      <h1 className="account-selector-header">Accounts</h1>
      <div className="account-selector-description">
        We see you have a number of accounts at T. Rowe Price. Please select one
        of the following options below to view details on that account.
      </div>
      <div>{accountsToSelect}</div>
    </div>
  );
};

AccountSelection.propTypes = {
  accountsForSelection: object.isRequired,
  currentAccountId: string.isRequired,
  onSelect: func.isRequired
};

const mapStateToProps = (state) => ({
  accountsForSelection: getAllAccountsforSelection(state)
});

export default connect(mapStateToProps)(AccountSelection);
